export default __webpack_public_path__ + "static/media/LVZ WEB ICONS - i TRANSLATE.9fbfb9e2.svg";